import type { ProjectPostDeleteCommand, ProjectPostDeleteResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class DeleteProjectPostUseCase {
  constructor(private projectRepository: ProjectRepository) {}

  async execute(command: ProjectPostDeleteCommand): Promise<ProjectPostDeleteResponse> {
    return this.projectRepository.deleteProjectPost(command);
  }
}
